import CommonSection from 'common/components/entities/Section'
import { SectionInterface } from 'common/components/entities/Section/types/SectionInterface'
import { getStickyCss } from 'common/components/entities/Section/utils/getStickyCss'
import { commonWidthValues } from 'common/constants/commonWidth'
import ChildrenEntities from 'publisher/components/ChildrenEntities'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { useBackgroundImage } from 'publisher/hooks/useBackgroundImage'
import { useWebsiteSettings } from 'publisher/store'
import React, { memo } from 'react'
import {
  getWebsiteStylesLayout,
  getWebsiteThemeBackground,
} from 'src/publisher/store/website-settings/website-settings-selector'
import { convertContentWidthToCommonWidth } from 'src/shared/utils/convert-content-width-to-common-width'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'
import { useDelay } from '../../../hooks/useDelay'
import { useScreenshotStyles } from './hooks/useScreenshotStyles'

interface SectionProps {
  entity: SectionInterface
}

const Section = ({ entity }: SectionProps) => {
  const { backgroundImage, mobileBackgroundImage } = useBackgroundImage({
    backgroundFileId: entity.backgroundFileId,
    mobileBackgroundFileId: entity.mobileBackgroundFileId,
  })
  const isVisible = useDelay(entity.delay)
  const screenshotStyles = useScreenshotStyles(entity)

  const layout = useWebsiteSettings(getWebsiteStylesLayout)
  const background = useWebsiteSettings(getWebsiteThemeBackground)
  const pageBackgroundImage = getBackgroundImageStyleValue(
    background?.pageBackgroundPicture?.file,
  )
  // NOTE: Make transparent background if page background image is set
  const backgroundColorFallback = pageBackgroundImage
    ? undefined
    : background?.pageBackgroundColor
  const contentBackgroundColor = background?.contentBackgroundColor

  const contentWidth =
    entity?.contentWidth ||
    (layout?.contentWidth &&
      convertContentWidthToCommonWidth(layout?.contentWidth))

  return isVisible ? (
    <StyleWrapper
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
      additionalCss={{ ...getStickyCss(entity.sticky), ...screenshotStyles }}
      mobileAdditionalCss={getStickyCss(entity.mobileSticky)}
    >
      <CommonSection
        backgroundImage={backgroundImage}
        mobileBackgroundImage={mobileBackgroundImage}
        htmlAttrId={entity.htmlAttrId}
        backgroundColor={entity.backgroundColor || backgroundColorFallback}
        mobileBackgroundColor={entity.mobileBackgroundColor}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        width={contentWidth && commonWidthValues[contentWidth]}
        containerBackgroundColor={
          entity.containerBackgroundColor || contentBackgroundColor
        }
        mobileContainerBackgroundColor={entity.mobileContainerBackgroundColor}
        background={entity.background}
        mobileBackground={entity.mobileBackground}
      >
        <ChildrenEntities childIds={entity.childIds} />
      </CommonSection>
    </StyleWrapper>
  ) : (
    <div />
  )
}

export default memo(Section)
